// Utils & misc
import cn from '../../../utils/cn';

// Styles
import styles from './DateRangePickerTimeRange.module.css';

/**
 * DateRangePickerTimeRange component - Time range picker for selecting start and end times
 * @param {object} props
 * @param {string} [props.className] - Additional CSS classes
 * @param {React.ReactNode} [props.children] - Children components
 * @returns {JSX.Element} DateRangePickerTimeRange component
 */
function DateRangePickerTimeRange({
  className,
  children,
}) {
  return (
    <div className={cn([styles['time-range-picker'], className])}>
      {children}
    </div>
  );
}

export default DateRangePickerTimeRange;

/**
 * TimeInputGroup component - Time input group for selecting start and end times
 * @param {object} props
 * @param {React.ReactNode} props.children - Children components
 * @returns {JSX.Element} TimeInputGroup component
 */
export function TimeInputGroup({ children }) {
  return (
    <div className={styles['time-input-group']}>
      {children}
    </div>
  );
}

/**
 * TimeInputWrapper component - Time input wrapper for selecting start and end times
 * @param {object} props
 * @param {React.ReactNode} props.children - Children components
 * @param {boolean} props.isOpen - Whether the time input wrapper is open
 * @returns {JSX.Element} TimeInputWrapper component
 */
export function TimeInputWrapper({ children, isOpen }) {
  return (
    <div className={cn([styles['time-input-wrapper'], isOpen ? styles.open : null])}>
      {children}
    </div>
  );
}
